export const PICKUP = 'pickup';
export const PICKUP_EMPTY = 'pickup_empty';
export const DELIVER = 'deliver';
export const DELIVER_EMPTY = 'deliver_empty';
const stopIntentList = [
    {
        slug: PICKUP_EMPTY,
        text: 'Pickup Empty',
        localizationSlug: 'PICKUP_EMPTY',
        titleize: true
    },
    {
        slug: PICKUP,
        text: 'Pickup',
        localizationSlug: 'PICKUP',
        titleize: true
    },
    {
        slug: DELIVER_EMPTY,
        text: 'Delivery Empty',
        localizationSlug: 'DELIVERY_EMPTY',
        titleize: true
    },
    {
        slug: DELIVER,
        text: 'Delivery',
        localizationSlug: 'DELIVERY',
        titleize: true
    },
];
export default stopIntentList;
